import React, { useState, useEffect, useMemo } from "react";
import { toast } from 'react-toastify';
import "../../../assets/styles/AccountSettings.css";
import LeftNav from '../common/LeftNav';
import TopNav from '../common/TopNav';
import bluemap from "../../assets/img/bluemap.svg";
import clock from "../../assets/img/clock.svg";

import { useNavigate, useLocation, useParams } from "react-router-dom";
import { FaTimes } from "react-icons/fa"; // ✅ Close icon
import vector from "../../assets/img/Vector.svg"
import locationIcon from "../../../assets/location.svg"; // your existing icon
import frame from '../../../assets/frame.png'
import frame1 from '../../../assets/frame2.png'
import { FaStar, FaMapMarkerAlt, FaPen, FaChevronRight } from "react-icons/fa";
import { FaRegStar } from "react-icons/fa";
import like from '../../../assets/like.png'
import dislike from '../../../assets/dislike.png'
import like1 from '../../../assets/like1.png'

import callIcon from "../../../assets/img/call.svg";
import userService from "../../../services/userService";
import propertyService from "../../../services/propertyService";
import authService from "../../../services/authService";
import crmService from "../../../services/crmService";

// Images
import builderprofile1 from "../../../assets/img/builderprofile.svg";
import builderprofile2 from "../../../assets/img/smallbuilderprofile.svg";

// Modal

const API_ORIGIN = process.env.REACT_APP_API_BASE_URL;

export default function AccountSettings() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  // Debug location state
  console.log('AgencyViewBuilder - Location state:', location.state);
  console.log('AgencyViewBuilder - Params:', params);

  const builderId = location.state?.builderId ||
    location.state?.builder?.id ||
    location.state?.userId ||
    location.state?.partnerData?.partner_id ||
    location.state?.user?.id ||
    params.builderId ||
    params.id;
  const routeLeadId = location.state?.leadId || null;

  console.log('AgencyViewBuilder - Extracted builderId:', builderId);

  const [loading, setLoading] = useState(true);
  const [showFullAbout, setShowFullAbout] = useState(false);
  const [builderData, setBuilderData] = useState(null);
  const [builderProjects, setBuilderProjects] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(false);

  const [isRegisteredWithBuilder, setIsRegisteredWithBuilder] = useState(false);
  const [registrationStatus, setRegistrationStatus] = useState(null);

  const [isOpen, setIsOpen] = useState(false);
  const [agencyName, setAgencyName] = useState("");
  const [managerName, setManagerName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [registering, setRegistering] = useState(false);
  const [managerOptions, setManagerOptions] = useState([]);
  const [loadingManagers, setLoadingManagers] = useState(false);
  const [isRegisterLeadOpen, setIsRegisterLeadOpen] = useState(false);
  const [agencyLeads, setAgencyLeads] = useState([]);
  const [loadingLeads, setLoadingLeads] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState("");
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [cityList, setCityList] = useState([]);
  const [loadingCities, setLoadingCities] = useState(false);
  const [leadNotes, setLeadNotes] = useState("");
  const [leadAgreeTerms, setLeadAgreeTerms] = useState(false);
  const [submittingLead, setSubmittingLead] = useState(false);
  const [leadRegistered, setLeadRegistered] = useState(false);
  const [leadRegistrationStatus, setLeadRegistrationStatus] = useState(null);
  const [builderRequiresRera, setBuilderRequiresRera] = useState(true);
  const [agencyHasRera, setAgencyHasRera] = useState(false);
  const [feedbackModal, setFeedbackModal] = useState({
    open: false,
    title: "",
    message: "",
    type: "info",
  });

  const [isAddReviewModalVisible, setAddReviewModalVisible] = useState(false);
  const [isAllReviewsModalVisible, setAllReviewsModalVisible] = useState(false);
  const [reviewType, setReviewType] = useState("positive");
  const [starRating, setStarRating] = useState(5);
  const [reviewComment, setReviewComment] = useState("");
  const [submittingReview, setSubmittingReview] = useState(false);
  const [allReviews, setAllReviews] = useState([]);
  const [loadingAllReviews, setLoadingAllReviews] = useState(false);
  const [isEditingReview, setIsEditingReview] = useState(false);
  const [loadingExistingReview, setLoadingExistingReview] = useState(false);

  const [activeTab, setActiveTab] = useState("Active");

  const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    if (typeof imagePath === "string") {
      if (imagePath.startsWith("http")) return imagePath;
      const clean = imagePath.startsWith("/") ? imagePath.slice(1) : imagePath;
      return `${API_ORIGIN}/${clean}`;
    }
    return null;
  };

  const getDisplayId = (data) => {
    if (data?.profile_id) return data.profile_id;
    if (data?.short_id) return data.short_id;
    const id = data?.id || data?._id || data?.builder_id;
    if (!id) return "N/A";
    if (String(id).length <= 12) return id;
    return String(id).replace(/-/g, "").substring(0, 6).toUpperCase();
  };

  const copyBuilderId = async () => {
    const idToCopy = getDisplayId(builderData);
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(idToCopy);
        toast.success(`ID ${idToCopy} copied`);
      } else {
        toast.info("Clipboard not supported in this browser");
      }
    } catch (error) {
      toast.error("Unable to copy ID");
    }
  };

  const extractBuilderPayload = (response) => {
    const level1 = response?.data ?? response;
    const level2 = level1?.data ?? level1;
    return level2 || {};
  };

  const applyBuilderPayload = (payload) => {
    const builderInfo = payload?.builder || payload || {};
    const reviewsList = payload?.reviews || [];
    const positiveCount = reviewsList.filter((r) => r.review_type === "positive").length;
    const negativeCount = reviewsList.filter((r) => r.review_type === "negative").length;

    setBuilderData((prev) => ({
      ...prev,
      ...builderInfo,
      reviews: reviewsList,
      positive_reviews: positiveCount,
      negative_reviews: negativeCount,
      total_reviews: payload?.review_stats?.total_reviews || reviewsList.length || 0,
      average_rating: payload?.review_stats?.average_rating || 0,
      achievements: payload?.achievements || prev?.achievements || [],
    }));
  };

  const reloadBuilderProfile = async () => {
    if (!builderId) return;
    const refresh = await userService.getBuilderPublicInfo(builderId);
    const payload = extractBuilderPayload(refresh);
    applyBuilderPayload(payload);
  };

  const profile = useMemo(
    () => ({
      name:
        builderData?.company_name ||
        builderData?.builder_company_name ||
        builderData?.companyName ||
        builderData?.business_name ||
        builderData?.businessName ||
        builderData?.builder_name ||
        builderData?.builderName ||
        builderData?.project_builder_name ||
        builderProjects?.[0]?.builder_company_name ||
        builderProjects?.[0]?.builder_name ||
        builderProjects?.[0]?.company_name ||
        builderData?.full_name ||
        builderData?.name ||
        "Builder",
      location:
        builderData?.location ||
        builderData?.locality ||
        builderData?.city ||
        builderData?.address ||
        "Location not specified",
      id: builderData?.id || builderData?._id || builderData?.builder_id || "N/A",
      displayId: getDisplayId(builderData),
      experience: builderData?.experience || "N/A",
      bannerImg: getImageUrl(builderData?.banner_image) || builderprofile1,
      profileImg:
        getImageUrl(builderData?.avatar_url || builderData?.logo || builderData?.company_logo) || builderprofile2,
    }),
    [builderData, builderProjects]
  );

  const builderPhone = builderData?.phone || builderData?.phone_number || builderData?.contact_number || "";
  const displayCompanyName =
    builderData?.company_name ||
    builderData?.builder?.company_name ||
    builderData?.data?.company_name ||
    builderData?.builder_company_name ||
    builderData?.builder?.builder_company_name ||
    builderData?.data?.builder_company_name ||
    builderData?.business_name ||
    builderData?.builder?.business_name ||
    builderData?.data?.business_name ||
    builderData?.full_name ||
    builderData?.builder?.full_name ||
    builderData?.data?.full_name ||
    builderData?.name ||
    builderData?.builder?.name ||
    builderData?.data?.name ||
    "Builder";
  const aboutText =
    builderData?.about ||
    builderData?.about_us ||
    builderData?.description ||
    builderData?.company_description ||
    builderData?.business_description ||
    "";
  const about = showFullAbout ? aboutText : aboutText ? `${aboutText.substring(0, 120)}...` : "";
  const stats = {
    sales: builderData?.sales_count ?? builderData?.total_sales ?? builderProjects.length ?? 0,
    partnerships: builderData?.partnerships_count ?? builderData?.total_partnerships ?? 0,
    revoked: builderData?.revoked_count ?? builderData?.total_revoked ?? 0,
  };
  const reviews = builderData?.reviews || [];
  const positiveReviews = builderData?.positive_reviews ?? reviews.filter((r) => r.review_type === "positive").length;
  const negativeReviews = builderData?.negative_reviews ?? reviews.filter((r) => r.review_type === "negative").length;
  const achievements = builderData?.achievements || [];
  const averageRating = builderData?.average_rating || 0;
  const totalReviews = builderData?.total_reviews || reviews.length || 0;

  // Function to render stars
  const renderStars = (rating, size = 16) => {
    const stars = [];
    const roundedRating = Math.round(rating);
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <FaStar
          key={i}
          size={size}
          color={i <= roundedRating ? "#FFC107" : "#E0E0E0"}
          style={{ marginRight: '2px' }}
        />
      );
    }
    return stars;
  };

  useEffect(() => {
    if (!builderId) {
      setLoading(false);
      return;
    }

    const loadBuilderProfile = async () => {
      try {
        setLoading(true);
        const response = await userService.getBuilderPublicInfo(builderId);
        const payload = extractBuilderPayload(response);
        const builderInfo = payload?.builder || payload || {};
        const statsData = payload?.statistics || {};
        const reviewStats = payload?.review_stats || {};
        const achievements = payload?.achievements || [];
        const reviewsList = payload?.reviews || [];
        const positiveCount = reviewsList.filter((r) => r.review_type === "positive").length;
        const negativeCount = reviewsList.filter((r) => r.review_type === "negative").length;

        setBuilderData({
          ...builderInfo,
          company_name:
            builderInfo?.company_name ||
            builderInfo?.builder_company_name ||
            builderInfo?.companyName ||
            builderInfo?.business_name ||
            builderInfo?.businessName ||
            builderInfo?.builder_name ||
            builderInfo?.builderName ||
            payload?.company_name ||
            payload?.builder_company_name ||
            payload?.name ||
            payload?.business_name ||
            "",
          sales_count: statsData.sales_count || 0,
          partnerships_count: statsData.partnerships_count || 0,
          revoked_count: statsData.revoked_count || 0,
          total_projects: statsData.total_projects || 0,
          active_projects: statsData.active_projects || 0,
          completed_projects: statsData.completed_projects || 0,
          reviews: reviewsList,
          positive_reviews: positiveCount,
          negative_reviews: negativeCount,
          total_reviews: reviewStats.total_reviews || reviewsList.length || 0,
          average_rating: reviewStats.average_rating || 0,
          achievements,
        });
        console.log("Builder name bind debug:", {
          company_name: builderInfo?.company_name,
          builder_company_name: builderInfo?.builder_company_name,
          name: builderInfo?.name,
          final_company_name:
            builderInfo?.company_name ||
            builderInfo?.builder_company_name ||
            builderInfo?.name ||
            payload?.company_name ||
            payload?.builder_company_name ||
            payload?.name ||
            ""
        });
      } catch (error) {
        console.warn("Failed to load builder profile:", error);
      } finally {
        setLoading(false);
      }
    };

    const loadBuilderProjects = async () => {
      try {
        console.log('AgencyViewBuilder - Loading projects for builderId:', builderId);
        setLoadingProjects(true);
        const response = await propertyService.getProjectsByBuilderId(builderId);
        console.log('AgencyViewBuilder - Projects API response:', response);
        const list = response?.data || response?.data?.data || response || [];
        setBuilderProjects(Array.isArray(list) ? list : []);
        console.log('AgencyViewBuilder - Set builder projects:', Array.isArray(list) ? list.length : 0, 'projects');
      } catch (error) {
        console.warn("Failed to load builder projects:", error);
        setBuilderProjects([]);
      } finally {
        setLoadingProjects(false);
      }
    };

    const checkAgentRegistration = async () => {
      try {
        const response = await userService.checkAgentRegistrationStatus(builderId);
        const data = response?.data || response;
        if (data) {
          const status = data.status || null;
          const registrationStatusValue = data.registration_status || status;
          const activationStatus = data.activation_status || null;

          const isAccepted = registrationStatusValue === "accepted" || registrationStatusValue === "active" || status === "active";
          const isPending = registrationStatusValue === "pending" || status === "pending";
          const isInactive = activationStatus === "inactive" || status === "inactive";
          const isDisabled = registrationStatusValue === "disabled" || status === "disabled";

          // Keep "registered" true for pending/accepted/active/inactive/disabled so UI doesn't fall back to Register button.
          const hasRegistered =
            data.registered_to_builder === true ||
            isPending ||
            isAccepted ||
            isInactive ||
            isDisabled;

          setIsRegisteredWithBuilder(hasRegistered);
          if (isDisabled) {
            setRegistrationStatus("disabled");
          } else if (isAccepted && isInactive) {
            setRegistrationStatus("inactive");
          } else if (isPending) {
            setRegistrationStatus("pending");
          } else if (isAccepted) {
            setRegistrationStatus("active");
          } else {
            setRegistrationStatus(status);
          }
          if (isAccepted) {
            checkLeadRegistrationForBuilder(builderId, routeLeadId || null);
          } else {
            setLeadRegistered(false);
            setLeadRegistrationStatus(null);
          }
        } else {
          setIsRegisteredWithBuilder(false);
          setRegistrationStatus(null);
        }
      } catch (error) {
        setIsRegisteredWithBuilder(false);
        setRegistrationStatus(null);
      }
    };

    const loadProfile = async () => {
      try {
        const response = await authService.getProfile();
        const user = response?.data?.user || response?.data || {};
        const fullName =
          user.full_name ||
          user.name ||
          [user.first_name, user.last_name].filter(Boolean).join(" ");
        if (fullName) setAgencyName(fullName);
        if (user.email) setEmail(user.email);
        if (user.phone) setPhoneNumber(user.phone);
        setAgencyHasRera(Boolean(user.rera_id || user.rera_number));
      } catch (error) {
        console.warn("Failed to load profile:", error);
      }
    };

    const checkReraRequirement = async () => {
      try {
        const response = await userService.getBuilderReraRequirement(builderId);
        const required = response?.data?.rera_required !== false;
        setBuilderRequiresRera(required);
      } catch (error) {
        setBuilderRequiresRera(true);
      }
    };

    const loadManagers = async () => {
      try {
        setLoadingManagers(true);
        const response = await userService.getSubUsers();
        const list = response?.data?.data || response?.data || response;
        if (Array.isArray(list)) {
          setManagerOptions(list);
        } else {
          setManagerOptions([]);
        }
      } catch (error) {
        setManagerOptions([]);
      } finally {
        setLoadingManagers(false);
      }
    };

    const checkExistingReview = async () => {
      try {
        const response = await userService.getMyReviewFor(builderId);
        if (response?.exists && response?.data) {
          setIsEditingReview(true);
        } else {
          setIsEditingReview(false);
        }
      } catch (error) {
        setIsEditingReview(false);
      }
    };

    loadBuilderProfile();
    loadBuilderProjects();
    checkAgentRegistration();
    loadProfile();
    checkReraRequirement();
    loadManagers();
    checkExistingReview();
  }, [builderId]);

  const handleSubmitRegistration = async (e) => {
    e.preventDefault();
    if (!agreeTerms) {
      toast.warning("Please accept terms and conditions");
      return;
    }
    if (builderRequiresRera && !agencyHasRera) {
      showFeedbackModal(
        "RERA Registration Required",
        "This builder only accepts RERA registered agencies. Please update your RERA number in your profile before registering.",
        "warning"
      );
      return;
    }
    if (!agencyName.trim() || !email.trim() || !phoneNumber.trim()) {
      toast.warning("Please fill all required fields");
      return;
    }
    try {
      setRegistering(true);
      const payload = {
        full_name: agencyName.trim(),
        manager_name: managerName.trim() || null,
        email: email.trim(),
        phone: phoneNumber.trim(),
        builder_id: builderId,
      };
      const response = await userService.registerAgentToBuilder(payload);
      if (response?.success || response?.data) {
        setIsOpen(false);
        setRegistrationStatus("pending");
        setIsRegisteredWithBuilder(true);
        toast.success("Registration submitted successfully");
      } else {
        toast.error(response?.message || "Failed to submit registration");
      }
    } catch (error) {
      toast.error("Failed to submit registration");
    } finally {
      setRegistering(false);
    }
  };

  const showFeedbackModal = (title, message, type = "info") => {
    setFeedbackModal({
      open: true,
      title,
      message,
      type,
    });
  };

  const fetchAgencyLeads = async () => {
    try {
      setLoadingLeads(true);
      const response = await crmService.getLeads();
      const raw = response?.data?.data || response?.data || [];
      const list = Array.isArray(raw) ? raw : [];
      setAgencyLeads(list);
      return list;
    } catch (error) {
      setAgencyLeads([]);
      return [];
    } finally {
      setLoadingLeads(false);
    }
  };

  const checkLeadRegistrationForBuilder = async (currentBuilderId, leadId = null) => {
    try {
      if (!currentBuilderId) return;
      const projectId = selectedProjectId || builderProjects?.[0]?.id || builderProjects?.[0]?._id || null;
      if (!projectId) return;
      const response = leadId
        ? await crmService.checkLeadRegistration(currentBuilderId, projectId, leadId)
        : await crmService.checkLeadRegistration(currentBuilderId, projectId);
      const data = response?.data?.data || response?.data || response || {};
      if (data?.registered) {
        const status = data?.registration?.status || "pending";
        setLeadRegistrationStatus(status);
        setLeadRegistered(status === "accepted");
      } else {
        setLeadRegistrationStatus(null);
        setLeadRegistered(false);
      }
    } catch (_error) {
      setLeadRegistrationStatus(null);
      setLeadRegistered(false);
    }
  };

  const fetchBuilderCities = async () => {
    if (!builderId) return;
    try {
      setLoadingCities(true);
      const response = await userService.getCityManagers(builderId);
      const data = response?.data || response;
      const cities = [];
      if (data?.parent?.city) cities.push(data.parent.city);
      if (Array.isArray(data?.city_managers)) {
        data.city_managers.forEach((cm) => {
          if (cm?.city && !cities.some((city) => city.toLowerCase() === cm.city.toLowerCase())) {
            cities.push(cm.city);
          }
        });
      }
      setCityList(cities);
      setSelectedCity(cities.length === 1 ? cities[0] : "");
    } catch (_error) {
      setCityList([]);
      setSelectedCity("");
    } finally {
      setLoadingCities(false);
    }
  };

  const handleRegisterLeadClick = async () => {
    let leads = agencyLeads;
    if (leads.length === 0) {
      leads = await fetchAgencyLeads();
    }
    if (!leads || leads.length === 0) {
      showFeedbackModal("No Leads", "You have no leads to register. Please add leads first.", "warning");
      return;
    }
    if (!selectedLeadId) {
      let nextLead = null;
      if (routeLeadId) {
        nextLead = leads.find((lead) => {
          const currentId = lead?.id || lead?._id || lead?.lead_id;
          return String(currentId) === String(routeLeadId);
        });
      }
      if (!nextLead) {
        const sortedByLatest = [...leads].sort(
          (a, b) =>
            new Date(b.created_at || b.createdAt || 0) - new Date(a.created_at || a.createdAt || 0)
        );
        nextLead = sortedByLatest[0];
      }
      setSelectedLeadId(nextLead?.id || nextLead?._id || nextLead?.lead_id || "");
    }
    if (!selectedProjectId && builderProjects.length > 0) {
      const firstProject = builderProjects[0];
      setSelectedProjectId(firstProject?.id || firstProject?._id || "");
    }
    fetchBuilderCities();
    setIsRegisterLeadOpen(true);
  };

  const handleSubmitLeadRegistration = async (e) => {
    e.preventDefault();
    if (!selectedLeadId) {
      showFeedbackModal("Missing Lead", "Please select a lead.", "error");
      return;
    }
    if (!selectedProjectId) {
      showFeedbackModal("Missing Project", "Please select a project.", "error");
      return;
    }
    if (!leadAgreeTerms) {
      showFeedbackModal("Terms Required", "Please accept terms and conditions.", "error");
      return;
    }

    const selectedLead = agencyLeads.find((l) => String(l.id || l._id || l.lead_id) === String(selectedLeadId));
    const selectedProject = builderProjects.find((p) => String(p.id || p._id) === String(selectedProjectId));

    try {
      setSubmittingLead(true);

      const checkResponse = await crmService.checkLeadRegistration(builderId, selectedProjectId, selectedLeadId);
      const checkData = checkResponse?.data?.data || checkResponse?.data || checkResponse || {};
      if (checkData?.registered && checkData?.registration) {
        const existingStatus = checkData.registration.status;
        setLeadRegistrationStatus(existingStatus);
        setLeadRegistered(existingStatus === "accepted");
        if (existingStatus === "pending") {
          showFeedbackModal("Request Pending", "Already request sent for this lead. Please wait for builder response.", "warning");
          return;
        }
        if (existingStatus === "accepted") {
          showFeedbackModal("Already Accepted", "This lead request has already been accepted by builder.", "warning");
          return;
        }
      }

      const leadName =
        selectedLead?.name ||
        selectedLead?.full_name ||
        selectedLead?.client_name ||
        [selectedLead?.first_name, selectedLead?.last_name].filter(Boolean).join(" ") ||
        "Unknown";

      const payload = {
        lead_id: selectedLeadId,
        lead_name: leadName,
        lead_phone: selectedLead?.phone || selectedLead?.mobile || null,
        lead_email: selectedLead?.email || null,
        builder_id: builderId,
        property_id: selectedProjectId,
        property_name: selectedProject?.property_title || selectedProject?.title || selectedProject?.name || "N/A",
        notes: leadNotes.trim() || null,
        city: selectedCity || null,
      };

      const response = await crmService.registerLeadWithBuilder(payload);
      const responseData = response?.data || {};
      const isSuccess = response?.success !== false && responseData?.success !== false;
      if (!isSuccess) {
        const message =
          responseData?.details ||
          responseData?.error ||
          responseData?.message ||
          response?.message ||
          "Failed to register lead.";
        showFeedbackModal("Registration Failed", message, "error");
        return;
      }

      setIsRegisterLeadOpen(false);
      setSelectedLeadId("");
      setSelectedProjectId("");
      setSelectedCity("");
      setLeadNotes("");
      setLeadAgreeTerms(false);
      setLeadRegistrationStatus("pending");
      showFeedbackModal("Success", "Lead registration request sent to builder.", "success");
    } catch (error) {
      const message =
        error?.data?.details ||
        error?.data?.error ||
        error?.message ||
        "Failed to register lead. Please try again.";
      showFeedbackModal("Error", message, "error");
    } finally {
      setSubmittingLead(false);
    }
  };

  const handleViewAllReviews = async () => {
    setAllReviewsModalVisible(true);
    if (!builderId) return;
    try {
      setLoadingAllReviews(true);
      const response = await userService.getBuilderReviewsById(builderId);
      const list = response?.data?.reviews || response?.data || response || [];
      setAllReviews(Array.isArray(list) ? list : []);
    } catch (error) {
      setAllReviews([]);
    } finally {
      setLoadingAllReviews(false);
    }
  };

  const handleOpenReviewModal = async () => {
    setLoadingExistingReview(true);
    setAddReviewModalVisible(true);
    try {
      const response = await userService.getMyReviewFor(builderId);
      if (response?.exists && response?.data) {
        const existing = response.data;
        setStarRating(existing.rating || 5);
        setReviewComment(existing.review || existing.review_text || "");
        setReviewType(existing.review_type || ((existing.rating || 0) >= 4 ? "positive" : "negative"));
        setIsEditingReview(true);
      } else {
        setStarRating(5);
        setReviewComment("");
        setReviewType("positive");
        setIsEditingReview(false);
      }
    } catch (error) {
      setIsEditingReview(false);
    } finally {
      setLoadingExistingReview(false);
    }
  };

  const handleSubmitReview = async () => {
    if (!reviewComment.trim()) {
      toast.warning("Please enter a review comment");
      return;
    }
    try {
      setSubmittingReview(true);
      const payload = {
        builder_id: builderId,
        review_type: reviewType,
        rating: starRating,
        comment: reviewComment.trim(),
      };
      const response = await userService.addBuilderReview(builderId, payload);
      if (response?.success || response?.data) {
        setReviewComment("");
        setReviewType("positive");
        setStarRating(5);
        setIsEditingReview(true);
        setAddReviewModalVisible(false);
        await reloadBuilderProfile();
        if (isAllReviewsModalVisible) {
          await handleViewAllReviews();
        }
      } else {
        toast.error(response?.message || "Failed to submit review");
      }
    } catch (error) {
      toast.error("Failed to submit review");
    } finally {
      setSubmittingReview(false);
    }
  };

  const handleLikeReview = async (reviewId) => {
    try {
      await userService.likeReview(reviewId);
      await reloadBuilderProfile();
      if (isAllReviewsModalVisible) {
        await handleViewAllReviews();
      }
    } catch (error) {
      toast.error("Unable to like review");
    }
  };

  const handleDislikeReview = async (reviewId) => {
    try {
      await userService.dislikeReview(reviewId);
      await reloadBuilderProfile();
      if (isAllReviewsModalVisible) {
        await handleViewAllReviews();
      }
    } catch (error) {
      toast.error("Unable to dislike review");
    }
  };


  const builderProjectsFiltered = useMemo(() => {
    const list = Array.isArray(builderProjects) ? builderProjects : [];
    return list.filter((project) => {
      const status = (project.status || "").toLowerCase();
      const projectStatus = (project.project_status || "").toLowerCase();
      if (activeTab === "Active") {
        const isActiveStatus = status === "active" || status === "ongoing" || status === "";
        const isActiveProjectStatus = projectStatus !== "completed" && projectStatus !== "sold";
        return isActiveStatus && isActiveProjectStatus;
      }
      return status === "completed" || status === "sold" || projectStatus === "completed" || projectStatus === "sold";
    });
  }, [builderProjects, activeTab]);


  return (
    <div>
      <LeftNav />
      <div className="main-content" style={{
        marginLeft: "250px",
        position: "absolute", top: "0px",
        width: "-webkit-fill-available"
      }}>
        <TopNav />
        <div className="p-3">
          <div className="account-settings container-fluid px-4 py-3">
            <div className="account-card p-4">
              <div className="banner position-relative">
                <img
                  src={profile.bannerImg}
                  alt="banner"
                  className="banner-img img-fluid w-100 rounded"
                />
                <div className="profile-logo position-absolute">
                  <img src={profile.profileImg} alt="profile" />
                </div>
              </div>
              <div className="profile-info d-flex justify-content-between align-items-start">
                <div>
                  <h5 className="profile-name mb-1" style={{ color: "#111827" }}>
                    {displayCompanyName || "Builder"}
                  </h5>
                  <p className="profile-location mb-2 mt-2">
                    <img src={bluemap} alt="map" /> {profile.location}
                  </p>
                  <p className="profile-idexp mt-1">
                    ID : {profile.displayId}
                    <button
                      type="button"
                      onClick={copyBuilderId}
                      style={{
                        border: "none",
                        background: "transparent",
                        color: "#2563eb",
                        marginLeft: "8px",
                        fontSize: "12px",
                        cursor: "pointer",
                      }}
                    >
                      Copy
                    </button>
                    <span className="ms-4">
                      <img
                        src={clock}
                        className="me-1 align-middle"
                        alt="clock"
                      />
                      {profile.experience} Experience
                    </span>
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    if (builderPhone) {
                      window.location.href = `tel:${builderPhone}`;
                    }
                  }}
                  style={{ border: "none", background: "transparent", padding: 0 }}
                >
                  <img src={callIcon} alt="call" width="36" height="36" />
                </button>
              </div>

              <div className="about-card mt-4 p-3">
                <h6 className="profile-aboutme mt-2">About Us</h6>
                <p className="profile-abouttext small mb-0">
                  {about || "No description available."}
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "20px",
                    marginTop: "20px",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  {/* Sales Card */}
                  <div
                    style={{
                      background: "#F6F6FE",
                      borderRadius: "12px",
                      padding: "14px 30px",
                      textAlign: "center",
                      flex: 1,
                    }}
                  >
                    <h4
                      style={{
                        color: "#3B82F6",
                        fontWeight: 700,
                        margin: 0,
                        fontSize: "22px",
                      }}
                    >
                      {stats.sales}
                    </h4>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "14px",
                        color: "#555",
                        fontWeight: 500,
                      }}
                    >
                      Sales
                    </p>
                  </div>

                  {/* Partnerships Card */}
                  <div
                    style={{
                      background: "#F6F6FE",
                      borderRadius: "12px",
                      padding: "14px 30px",
                      textAlign: "center",
                      flex: 1,
                    }}
                  >
                    <h4
                      style={{
                        color: "#6366F1",
                        fontWeight: 700,
                        margin: 0,
                        fontSize: "22px",
                      }}
                    >
                      {stats.partnerships}
                    </h4>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "14px",
                        color: "#555",
                        fontWeight: 500,
                      }}
                    >
                      Partnerships
                    </p>
                  </div>

                  {/* Revoked Card */}
                  <div
                    style={{
                      background: "#F6F6FE",
                      borderRadius: "12px",
                      padding: "14px 30px",
                      textAlign: "center",
                      flex: 1,
                    }}
                  >
                    <h4
                      style={{
                        color: "#4B5563",
                        fontWeight: 700,
                        margin: 0,
                        fontSize: "22px",
                      }}
                    >
                      {stats.revoked}
                    </h4>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "14px",
                        color: "#555",
                        fontWeight: 500,
                      }}
                    >
                      Revoked
                    </p>
                  </div>
                </div>







              </div>

              <div
                style={{
                  background: "#fff",
                  borderRadius: "16px",
                  padding: "20px",
                  border: "1px solid #e5e7eb",
                  width: "100%",

                  margin: "30px auto",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <h3
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      color: "#111827",
                      margin: 0,
                    }}
                  >
                    Projects
                  </h3>

                  {/* Tabs */}
                  <div
                    style={{
                      display: "flex",
                      background: "#f3f4f6",
                      borderRadius: "25px",
                      padding: "4px",
                    }}
                  >
                    {["Active", "Completed"].map((tab) => (
                      <button
                        key={tab}
                        onClick={() => setActiveTab(tab)}
                        style={{
                          padding: "6px 20px",
                          borderRadius: "20px",
                          border: "none",
                          background:
                            activeTab === tab ? "#111827" : "transparent",
                          color: activeTab === tab ? "#fff" : "#6b7280",
                          fontWeight: 500,
                          cursor: "pointer",
                          fontSize: "14px",
                          transition: "0.3s",
                        }}
                      >
                        {tab}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Cards */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 260px))",
                    gap: "10px",
                    justifyContent: "flex-start",
                  }}
                >
                  {loadingProjects ? (
                    <div style={{ gridColumn: "1 / -1", textAlign: "center", color: "#6b7280" }}>
                      Loading projects...
                    </div>
                  ) : builderProjectsFiltered.length > 0 ? (
                    builderProjectsFiltered.map((p, i) => (
                      <div
                        key={p.id || p._id || i}
                        style={{
                          background: "#fff",
                          border: "1px solid #e5e7eb",
                          borderRadius: "14px",
                          overflow: "hidden",
                          boxShadow: "0 1px 5px rgba(0,0,0,0.05)",
                          cursor: "pointer",
                          transition: "transform 0.2s",
                          width: "100%",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.transform = "translateY(-4px)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.transform = "translateY(0)")
                        }
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/admin-projectdetails/${p.id || p._id}`, {
                            state: {
                              project: {
                                id: p?.id || p?._id || null,
                                _id: p?._id || p?.id || null,
                                title: p?.title || p?.property_title || p?.name || "Property",
                                property_title: p?.property_title || p?.title || p?.name || "Property",
                                location: p?.location || p?.address || p?.locality || p?.city || "",
                                address: p?.address || p?.location || "",
                                city: p?.city || "",
                                locality: p?.locality || "",
                                builder_id: p?.builder_id || p?.user_id || null,
                                user_id: p?.user_id || p?.builder_id || null,
                                thumbnail: p?.thumbnail || p?.project_logo || null,
                                project_logo: p?.project_logo || p?.thumbnail || null,
                                images: Array.isArray(p?.images) ? p.images.slice(0, 8) : [],
                                distances: Array.isArray(p?.distances) ? p.distances.slice(0, 4) : [],
                              }
                            }
                          });
                        }}
                      >
                        {/* Image */}
                        <div style={{ width: "100%", height: "140px", overflow: "hidden" }}>
                          <img
                            src={
                              getImageUrl(
                                p.thumbnail ||
                                (Array.isArray(p.images) && p.images.length > 0 ? p.images[0] : null)
                              ) || "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=500"
                            }
                            alt={p.property_title || p.title || "Project"}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </div>

                        {/* Content */}
                        <div style={{ padding: "12px 14px" }}>
                          <h4
                            style={{
                              fontSize: "14px",
                              fontWeight: 600,
                              color: "#111827",
                              margin: "0 0 6px 0",
                            }}
                          >
                            {p.property_title || p.title || p.name || "Project"}
                          </h4>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              color: "#6b7280",
                              fontSize: "13px",
                              marginBottom: "10px",
                            }}
                          >
                            <img src={locationIcon} alt="location" width={12} height={12} />
                            <span>{p.address || p.location || p.locality || "Location not specified"}</span>
                          </div>

                          <div
                            style={{
                              fontSize: "12px",
                              color: "#6b7280",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <span>{p.created_at ? new Date(p.created_at).toLocaleDateString() : ""}</span>
                            <span
                              style={{
                                fontSize: "18px",
                                fontWeight: "bold",
                                color: "#6b7280",
                                lineHeight: "1",
                              }}
                            >
                              ...
                            </span>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div style={{ gridColumn: "1 / -1", textAlign: "center", color: "#6b7280" }}>
                      No projects found.
                    </div>
                  )}
                </div>
              </div>


              <div
                style={{
                  fontFamily: "Manrope, sans-serif",
                  backgroundColor: "#fff",
                  border: "1px solid #E5E7EB",
                  borderRadius: "12px",
                  padding: "20px",
                  width: "100%",
                  marginTop: "30px",
                  margin: "0 auto",
                }}
              >
                <h5
                  style={{
                    fontWeight: 700,
                    fontSize: "16px",
                    marginBottom: "16px",
                  }}
                >
                  Achievements
                </h5>

                <div
                  style={{
                    display: "flex",
                    gap: "16px",
                    flexWrap: "wrap",
                    justifyContent: "center",
                  }}
                >
                  {achievements.length > 0 ? (
                    achievements.map((achievement, index) => (
                      <div
                        key={achievement.id || achievement._id || index}
                        style={{
                          backgroundColor: "#F4F4F4",
                          borderRadius: "12px",
                          padding: "8px",
                          textAlign: "center",
                          width: "265px",
                          boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
                        }}
                      >
                        <img
                          src={getImageUrl(achievement.image_url || achievement.image) || frame}
                          alt="Achievement"
                          style={{
                            width: "100%",
                            height: "120px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            marginBottom: "8px",
                          }}
                        />
                        <p
                          style={{
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#000",
                            margin: 0,
                          }}
                        >
                          {achievement.title || achievement.name || "Achievement"}
                        </p>
                      </div>
                    ))
                  ) : (
                    <p style={{ color: "#6b7280", margin: 0 }}>No achievements available.</p>
                  )}
                </div>
              </div>
              <div
                style={{
                  border: "1px solid #DDDCDC",  // Grey border
                  borderRadius: "12px",

                  overflow: "hidden",
                  fontFamily: "Arial, sans-serif",
                  color: "#000",
                  padding: "10px 20px", // ⬅ adds inner left/right padding
                  marginTop: "30px",

                }}

              >
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "15px",
                  }}
                >
                  <h5 style={{ margin: 0, fontWeight: 600 }}>Builder Ratings & Reviews</h5>
                  <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "6px", width: "150px" }}>
                      {/* Likes & Dislikes Row */}
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <img src={like} alt="like" width="20" height="20" />
                        <span style={{ fontSize: "14px", color: "#111827" }}>{positiveReviews}</span>
                        <img src={dislike} alt="dislike" width="20" height="20" />
                        <span style={{ fontSize: "14px", color: "#111827" }}>{negativeReviews}</span>
                      </div>

                      {/* Ratio Bar */}
                      <div
                        style={{
                          width: "100%",
                          height: "5px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "3px",
                          overflow: "hidden",
                          display: "flex",
                        }}
                      >
                        {/* Green portion (likes) */}
                        <div
                          style={{
                            width: `${positiveReviews + negativeReviews > 0 ? (positiveReviews / (positiveReviews + negativeReviews)) * 100 : 0}%`,
                            backgroundColor: "#22c55e",
                            height: "100%",
                          }}
                        ></div>
                        {/* Red portion (dislikes) */}
                        <div
                          style={{
                            width: `${positiveReviews + negativeReviews > 0 ? (negativeReviews / (positiveReviews + negativeReviews)) * 100 : 0}%`,
                            backgroundColor: "#ef4444",
                            height: "100%",
                          }}
                        ></div>
                      </div>
                    </div>

                  </div>
                </div>

                {/* Reviews */}
                {reviews.length === 0 ? (
                  <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "12px" }}>
                    No reviews available yet.
                  </p>
                ) : (
                  reviews.map((review, index) => (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        border: "1px solid #e5e7eb",
                        borderRadius: "10px",
                        padding: "18px",
                        marginBottom: "15px",
                        backgroundColor: "#fff",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                      }}
                    >
                      {/* Header Section */}
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={
                              getImageUrl(review.reviewer_avatar || review.avatar_url) ||
                              review.image ||
                              frame
                            }
                            alt={review.reviewer_name || review.name || "Reviewer"}
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              objectFit: "cover",
                              marginRight: "10px",
                            }}
                          />
                          <h6
                            style={{
                              margin: 0,
                              fontWeight: 600,
                              fontSize: "15px",
                              color: "#111827",
                            }}
                          >
                            {review.reviewer_name || review.name || "Anonymous"}
                          </h6>
                        </div>

                        {/* Star Rating (top-right) */}
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {renderStars(review.rating || review.star_rating || (review.review_type === "positive" ? 4 : 2), 14)}
                        </div>
                      </div>

                      {/* Review Text */}
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#374151",
                          marginBottom: "8px",
                          lineHeight: "1.5",
                        }}
                      >
                        {review.comment || review.text || "No comments yet."}
                      </p>

                      {/* Date */}
                      <p style={{ fontSize: "12px", color: "#9ca3af", margin: 0 }}>
                        {review.created_at ? new Date(review.created_at).toLocaleDateString() : review.date || ""}
                      </p>
                    </div>
                  ))
                )}


                {/* Action Buttons */}
                {/* <div style={{ display: "flex", gap: "8px", marginTop: "16px" }}>
                  <button
                    style={{
                      flex: 1,
                      border: "1px solid #6366f1",
                      borderRadius: "8px",
                      padding: "10px 0",
                      color: "#6366f1",
                      background: "#fff",
                      fontWeight: 600,
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                    onClick={handleViewAllReviews}
                  >
                    View All Reviews
                  </button>
                  <button
                    style={{
                      flex: 1,
                      border: "none",
                      borderRadius: "8px",
                      padding: "10px 0",
                      color: "#fff",
                      background: "#6366f1",
                      fontWeight: 600,
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                    onClick={handleOpenReviewModal}
                  >
                    {isEditingReview ? "Edit Review" : "Add Review"}
                  </button>
                </div> */}
              </div>



            </div>
          </div>
        </div>
      </div>

      {/* View All Reviews Modal */}
      {isAllReviewsModalVisible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "12px",
              width: "520px",
              maxHeight: "80vh",
              overflowY: "auto",
              position: "relative",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 style={{ margin: 0 }}>All Reviews</h3>
              <button
                type="button"
                style={{ border: "none", background: "transparent" }}
                onClick={() => setAllReviewsModalVisible(false)}
              >
                <FaTimes />
              </button>
            </div>

            {loadingAllReviews ? (
              <p style={{ color: "#6b7280" }}>Loading reviews...</p>
            ) : allReviews.length > 0 ? (
              allReviews.map((review, index) => (
                <div
                  key={review.id || review._id || index}
                  style={{
                    border: "1px solid #e5e7eb",
                    borderRadius: "10px",
                    padding: "12px",
                    marginBottom: "12px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <img
                      src={
                        getImageUrl(review.reviewer_avatar || review.avatar_url) ||
                        review.image ||
                        frame
                      }
                      alt="reviewer"
                      style={{ width: 36, height: 36, borderRadius: "50%" }}
                    />
                    <strong>{review.reviewer_name || review.name || "Anonymous"}</strong>
                  </div>
                  <p style={{ marginTop: "8px", marginBottom: "6px" }}>
                    {review.comment || review.text || "No comments yet."}
                  </p>
                  <p style={{ fontSize: "12px", color: "#9ca3af", marginBottom: 0 }}>
                    {review.created_at ? new Date(review.created_at).toLocaleDateString() : ""}
                  </p>
                </div>
              ))
            ) : (
              <p style={{ color: "#6b7280" }}>No reviews found.</p>
            )}
          </div>
        </div>
      )}

      {/* Add Review Modal */}
      {isAddReviewModalVisible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "12px",
              width: "480px",
              position: "relative",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 style={{ margin: 0 }}>{isEditingReview ? "Edit Your Review" : "Add Review"}</h3>
              <button
                type="button"
                style={{ border: "none", background: "transparent" }}
                onClick={() => setAddReviewModalVisible(false)}
              >
                <FaTimes />
              </button>
            </div>

            {loadingExistingReview ? (
              <p style={{ marginBottom: "12px", color: "#6b7280" }}>Loading...</p>
            ) : (
              <>
                {isEditingReview && (
                  <p style={{ marginBottom: "10px", color: "#6366f1", fontSize: "12px", fontStyle: "italic" }}>
                    You already reviewed this builder. Submitting will update your review.
                  </p>
                )}

                <div style={{ marginBottom: "12px" }}>
                  <label>Review Type</label>
                  <div style={{ display: "flex", gap: "8px", marginTop: "6px" }}>
                    {["positive", "negative"].map((type) => (
                      <button
                        type="button"
                        key={type}
                        onClick={() => setReviewType(type)}
                        style={{
                          flex: 1,
                          padding: "8px",
                          borderRadius: "8px",
                          border: "1px solid #e5e7eb",
                          background: reviewType === type ? "#6366f1" : "#fff",
                          color: reviewType === type ? "#fff" : "#111827",
                        }}
                      >
                        {type === "positive" ? "Positive" : "Negative"}
                      </button>
                    ))}
                  </div>
                </div>

                <div style={{ marginBottom: "12px" }}>
                  <label>Rating</label>
                  <div style={{ display: "flex", gap: "6px", marginTop: "6px" }}>
                    {[1, 2, 3, 4, 5].map((star) => (
                      <button
                        type="button"
                        key={star}
                        onClick={() => setStarRating(star)}
                        style={{
                          border: "none",
                          background: "transparent",
                          fontSize: "18px",
                          color: star <= starRating ? "#f59e0b" : "#d1d5db",
                        }}
                      >
                        ★
                      </button>
                    ))}
                  </div>
                </div>

                <div style={{ marginBottom: "12px" }}>
                  <label>Comment</label>
                  <textarea
                    value={reviewComment}
                    onChange={(e) => setReviewComment(e.target.value)}
                    rows={4}
                    style={{
                      width: "100%",
                      marginTop: "6px",
                      padding: "8px",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                    }}
                  />
                </div>

                <button
                  type="button"
                  onClick={handleSubmitReview}
                  style={{
                    background: "#6F70FA",
                    color: "#fff",
                    padding: "10px",
                    border: "none",
                    borderRadius: "6px",
                    fontWeight: "600",
                    cursor: "pointer",
                    width: "100%",
                  }}
                  disabled={submittingReview}
                >
                  {submittingReview ? "Submitting..." : (isEditingReview ? "Update Review" : "Submit Review")}
                </button>
              </>
            )}
          </div>
        </div>
      )}

      {/* Register Lead Modal */}
      {isRegisterLeadOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "12px",
              width: "460px",
              position: "relative",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 style={{ margin: 0 }}>Register Lead</h3>
              <button
                type="button"
                style={{ border: "none", background: "transparent" }}
                onClick={() => setIsRegisterLeadOpen(false)}
              >
                <FaTimes />
              </button>
            </div>

            <form onSubmit={handleSubmitLeadRegistration}>
              <div style={{ marginBottom: "12px" }}>
                <label>Select Lead</label>
                <select
                  value={selectedLeadId}
                  onChange={(e) => setSelectedLeadId(e.target.value)}
                  style={{
                    width: "100%",
                    marginTop: "5px",
                    padding: "8px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    background: "#fff",
                  }}
                  required
                >
                  <option value="">{loadingLeads ? "Loading leads..." : "Select lead"}</option>
                  {agencyLeads.map((lead) => {
                    const id = lead.id || lead._id || lead.lead_id;
                    const label =
                      lead.name ||
                      lead.full_name ||
                      lead.client_name ||
                      [lead.first_name, lead.last_name].filter(Boolean).join(" ") ||
                      lead.email ||
                      "Lead";
                    return (
                      <option key={id} value={id}>
                        {label}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div style={{ marginBottom: "12px" }}>
                <label>Select Project</label>
                <select
                  value={selectedProjectId}
                  onChange={(e) => setSelectedProjectId(e.target.value)}
                  style={{
                    width: "100%",
                    marginTop: "5px",
                    padding: "8px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    background: "#fff",
                  }}
                  required
                >
                  <option value="">Select project</option>
                  {builderProjects.map((project) => {
                    const id = project.id || project._id;
                    const label = project.property_title || project.title || project.name || "Project";
                    return (
                      <option key={id} value={id}>
                        {label}
                      </option>
                    );
                  })}
                </select>
              </div>

              {cityList.length > 0 && (
                <div style={{ marginBottom: "12px" }}>
                  <label>City</label>
                  {loadingCities ? (
                    <div
                      style={{
                        width: "100%",
                        marginTop: "5px",
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        background: "#f9fafb",
                        color: "#6b7280",
                      }}
                    >
                      Loading cities...
                    </div>
                  ) : cityList.length === 1 ? (
                    <div
                      style={{
                        width: "100%",
                        marginTop: "5px",
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        background: "#f9fafb",
                        color: "#111827",
                      }}
                    >
                      {cityList[0]}
                    </div>
                  ) : (
                    <select
                      value={selectedCity}
                      onChange={(e) => setSelectedCity(e.target.value)}
                      style={{
                        width: "100%",
                        marginTop: "5px",
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        background: "#fff",
                      }}
                    >
                      <option value="">Select city</option>
                      {cityList.map((city) => (
                        <option key={city} value={city}>
                          {city}
                        </option>
                      ))}
                    </select>
                  )}
                </div>
              )}

              <div style={{ marginBottom: "12px" }}>
                <label>Notes (Optional)</label>
                <textarea
                  value={leadNotes}
                  onChange={(e) => setLeadNotes(e.target.value)}
                  rows={3}
                  style={{
                    width: "100%",
                    marginTop: "5px",
                    padding: "8px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                />
              </div>

              <div style={{ marginBottom: "14px", display: "flex", alignItems: "center" }}>
                <input
                  id="lead-agree-terms"
                  type="checkbox"
                  checked={leadAgreeTerms}
                  onChange={(e) => setLeadAgreeTerms(e.target.checked)}
                  style={{ marginRight: "8px" }}
                />
                <label htmlFor="lead-agree-terms" style={{ margin: 0 }}>
                  I agree to terms and conditions
                </label>
              </div>

              <button
                type="submit"
                style={{
                  background: "#4CAF50",
                  color: "#fff",
                  padding: "10px",
                  border: "none",
                  borderRadius: "6px",
                  fontWeight: "600",
                  cursor: "pointer",
                  width: "100%",
                }}
                disabled={submittingLead}
              >
                {submittingLead ? "Submitting..." : "Register Lead"}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Feedback Modal (for Register Lead flow) */}
      {feedbackModal.open && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.35)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
          }}
          onClick={() => setFeedbackModal((prev) => ({ ...prev, open: false }))}
        >
          <div
            style={{
              width: "380px",
              maxWidth: "90vw",
              background: "#fff",
              borderRadius: "12px",
              padding: "18px 18px 14px",
              boxShadow: "0 12px 32px rgba(0,0,0,0.2)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>
                {feedbackModal.title}
              </h6>
              <button
                type="button"
                onClick={() => setFeedbackModal((prev) => ({ ...prev, open: false }))}
                style={{ border: "none", background: "transparent", cursor: "pointer", fontSize: 20, lineHeight: 1 }}
              >
                x
              </button>
            </div>
            <p style={{ margin: 0, fontSize: 14, color: "#374151", lineHeight: 1.5 }}>
              {feedbackModal.message}
            </p>
            <div className="d-flex justify-content-end mt-3">
              <button
                type="button"
                onClick={() => setFeedbackModal((prev) => ({ ...prev, open: false }))}
                style={{
                  border: "none",
                  borderRadius: "8px",
                  padding: "8px 14px",
                  color: "#fff",
                  background:
                    feedbackModal.type === "success"
                      ? "#16a34a"
                      : feedbackModal.type === "warning"
                        ? "#d97706"
                        : "#dc2626",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
